import { useQuery } from "@tanstack/react-query";
import api from "../../../../utils/api";
import { Dispatch, useCallback, useState } from "react";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import useAuth from "../../../../hooks/useAuth";

export interface ServicesLideresProps {
  pgs: TInfoPg[],
  handleFilter: VoidFunction,
  alterCampos: (campo: 'sede' | 'ministerio' | 'celula', value: any) => void,
  reset: VoidFunction,
  isLoading: boolean,
  pesquisarPorNome: string | undefined,
  getSearchPerNome: (e: any) => void
  filas: { fila: number, tamanho: number },
  setFilas: Dispatch<{ fila: number, tamanho: number }>,
  dados: {
    ministerio: string | undefined,
    sede: string | undefined,
    celula: string | undefined
  }
 }

export type TInfoPg = {
  celula: number,
  nomecelula: string,
  ministerio: number,
  nomeministerio: string,
  sede: number,
  nomesede: string,
  frequencia: string,
  bairro: string,
  membros: number,
  idevento: number
};

const ServicesInfoPg = () => {

  const { setErrorSuccess, setMensagemError } = useErrorSuccess();
  const { idUsuario } = useAuth()

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sede, setSede] = useState<string>('0');
  const [ministerio, setMinisterio] = useState<string>('0');
  const [celula, setCelula] = useState<string>('0');
  const [pesquisarPorNome, setPesquisarPorNome] = useState<string>('');
  const [filas, setFilas] = useState<{ fila: number, tamanho: number }>({ fila: 0, tamanho: 300 });

  const getSearchPerNome = (e: any) => setPesquisarPorNome(e.target.value.replace(/script/g, ""))

  const get = useCallback(async () => {
    invertLoading();
    try {
      const data = await api.get<TInfoPg[]>(`view/conexaopg/${idUsuario}/${sede}/${ministerio}/${celula}`);
      const res = data.data;

      return res;
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data));
    } finally {
      invertLoading();
    }
  }, [sede, ministerio, celula])

  const { data: pgs = [], refetch } = useQuery({
    queryFn: get,
    queryKey: ['pgs-lista', sede, ministerio, celula, pesquisarPorNome]
  });


  const getWithParams = async () => {
    if(isLoading) { return; }
    try {
      invertLoading();
      await refetch()
    } catch (error) {
      setErrorSuccess({
        mensagem: error?.response?.data,
        status: 'error'
      });
    } finally {
      invertLoading();
    }
  }

  const invertLoading = () => setIsLoading((value) => !value);

  const clearParams = () => {
    setMinisterio('0');
    setCelula('0');
    setSede('0');
  }

  const reset = async () => {

    if(isLoading) { return; }

    invertLoading();

    clearParams();

    await refetch();

    invertLoading();

  }

  const alterCampos = (campo: 'sede' | 'ministerio' | 'celula', value: any) => {
    switch(campo) {
      case 'sede':
          setSede(value);
          return;

      case 'ministerio':
          setMinisterio(value);
          return;

      default:
        setCelula(value);
          return;
    }
  }

  return {
    pgs,
    handleFilter: getWithParams,
    alterCampos,
    isLoading,
    getSearchPerNome,
    pesquisarPorNome,
    reset,
    setFilas,
    filas,
    dados: {
      ministerio,
      sede,
      celula
    }
  };
};

export default ServicesInfoPg;
